import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";

const getSubcompany = () => {
  return axios.get(API + "company/subcompanies/", { headers: authHeader() });
};

const createSubcompany = (data) => {
  return axios.post(API + "company/subcompanies/create/", data, {
    headers: authHeader(),
  });
};

const updateSubcompany = (id, data) => {
  return axios.put(API + `company/subcompanies/${id}/update/`, data, {
    headers: authHeader(),
  });
};

const deleteSubcompany = (id) => {
  return axios.delete(API + `company/subcompanies/${id}/delete/`, {
    headers: authHeader(),
  });
};


const createClient = (data) => {
  return axios.post(API + "company/create-client/", data, {
    headers: authHeader(),
  });
};

const getMyClients = () => {
  return axios.get(API + "company/my-clients/", { headers: authHeader() });
};

const getArchivedClients = () => {
  return axios.get(API + "company/my-clients/archived/", { headers: authHeader() });
};

const getClientDetail = (companyId) => {
  return axios.get(API + `company/my-clients/${companyId}/detail/`, { headers: authHeader() });
};

const archiveClient = (companyId) => {
  return axios.post(API + `company/my-clients/${companyId}/archive/`, {}, { headers: authHeader() });
};

const reinstateClient = (companyId) => {
  return axios.post(API + `company/my-clients/${companyId}/reinstate/`, {}, { headers: authHeader() });
};

const getPlans = () =>
  axios.get(API + "paymentsub/subscription/plan/", { headers: authHeader() });

const subcompanyService = {
  getSubcompany,
  createSubcompany,
  updateSubcompany,
  deleteSubcompany,
  createClient,
  getMyClients,
  getArchivedClients,
  getClientDetail,
  archiveClient,
  reinstateClient,
  getPlans,
};

export default subcompanyService;
